export default "__VITE_PUBLIC_ASSET__e354cb50__"